import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import { TooltipDirective } from '../../../directives/tooltip.directive';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-reset-date',
    templateUrl: './reset-date.component.html',
    styleUrls: ['./reset-date.component.scss'],
    standalone: false
})
export class ResetDateComponent {
  @ViewChild(TooltipDirective) tooltipEl: TooltipDirective;

  @Input() dateSelected: boolean;
  @Input() resetDisabled = false;

  @Output() resetDate = new EventEmitter();

  resetExpectedProjectDate() {
    this.tooltipEl.hide();
    this.resetDate.emit();
  }
}
